import script from "./BillingFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingFooter.vue?vue&type=script&setup=true&lang=js"

import "./BillingFooter.vue?vue&type=style&index=0&id=20ebd812&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ebd812"]])

export default __exports__